import * as React from "react";
import axios from "axios";
import * as dataResultsEmployee from "../data.results.employee.json";
import * as dataResultsEmployer from "../data.results.employer.json";
const dataAll = {
  employee: dataResultsEmployee,
  employer: dataResultsEmployer
};
import "./Results.css";
const _ = require("lodash");

const whichTribeIsTheWinner = (weightings: any[]) => {
  // Dumb code but want to make certain it's the winning ID for array tribes index use
  let highestWeightingIndex = 0,
    highestWeighting = 0;
  weightings.forEach((w, i) => {
    if (w > highestWeighting) {
      highestWeightingIndex = i;
      highestWeighting = w;
    }
  });
  return highestWeightingIndex; // [0-3]
};

const flattenQuestionsAndAnswers = (questionsAndAnswers: any) => {
  return questionsAndAnswers.map((q: any) => {
    return {
      question: q.content,
      answer: q.answer.content
    };
  });
};

export default class extends React.Component<
  // Props
  {
    questionsAndAnswers: any[];
    company: string;
    userInfo: any[];
    weightings: any[];
    employmentType: string;
  },
  // States
  {
    winner: any;
    fixedWinner: any;
    url: any;
    data: { intro: any; tribes: any[] };
  }
> {
  constructor(props: any) {
    super(props);
  }

  submitToDatabase() {
    let post = {
      company: this.props.company,
      type: this.props.employmentType,
      result: this.state.winner.data.name,
      answers: flattenQuestionsAndAnswers(this.props.questionsAndAnswers)
    };
    this.props.userInfo.forEach(u => (post[u.name] = u.answer));

    // How it might fire the data over to an endpoint
    console.log("DATA TO SUBMIT:\n", post);
    console.log("SUBMITTING..");
    const baseUrl =
      window.location.hostname === "unum-quiz.azurewebsites.net"
        ? "https://unumquiz-func.azurewebsites.net"
        : "https://unumquiz-qa-func.azurewebsites.net";

    axios
      .post(`${baseUrl}/api/Submit`, post)
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
      });
  }

  setWinnerId(id: number) {
    this.setState(
      {
        winner: {
          id: id,
          data: this.state.data.tribes[id]
        }
      },
      () => {
        this.submitToDatabase();
      }
    );
  }
  // Have a fixed winner state too, so that you can't cheekily change
  // your winning tribe and 'share on twitter' with that version.
  setFixedWinnerId(id: number) {
    this.setState({
      fixedWinner: {
        id: id,
        data: this.state.data.tribes[id]
      }
    });
  }
  componentDidMount() {
    let winnerId = whichTribeIsTheWinner(this.props.weightings);

    this.setState(
      {
        data: dataAll[this.props.employmentType],
        url: window.location
      },
      () => {
        this.setWinnerId(winnerId);
        this.setFixedWinnerId(winnerId);
      }
    );

    // Add #1 or up to #4 to the URL for facebook og data share reasons
    window.location.hash = `result-${this.props.employmentType}-${winnerId}`;
  }
  reload() {
    location.reload();
  }
  barClick(id: number) {
    this.setWinnerId(id);
  }
  render() {
    if (!this.state || !this.state.winner || !this.props.weightings) {
      return null; // loading
    }

    //
    // BARS
    //
    // Making sure we get the order right so that, for tied positions, the lowest index wins
    // { label: "Tribe 1", value: 6 },
    // { label: "Tribe 2", value: 6 },
    // { label: "Tribe 3", value: 7 },
    // { label: "Tribe 4", value: 5 }
    //            -->
    // (Tribe 2) 27.27272727272727%
    // (Tribe 3) 27.27272727272727%
    // (Tribe 1) 22.727272727272727%
    // (Tribe 4) 22.727272727272727%
    //
    let weightingsWithLabels = this.props.weightings.map((w, i) => {
      return {
        id: i,
        label: "Tribe " + i,
        value: w
      };
    });
    let weightingsOrdered = _.orderBy(weightingsWithLabels, "value", "desc");
    let highestPercentage = weightingsOrdered[0].value;
    // Sleuth through the weighting results showing percentages bars for each
    let tribeInfo = weightingsOrdered.map((weighting: any, i: number) => {
      let name = this.state.data.tribes[weighting.id].name; // Phew!
      // let letter = ["A", "B", "C", "D", "E", "F"][i];
      let percentage = weighting.value;
      let barWidth = (percentage / highestPercentage) * 100;
      return (
        <li key={i}>
          <h2>{name}</h2>
          <a
            key={i}
            className="bar"
            href="#"
            onClick={() => this.barClick(weighting.id)}
            style={{ width: barWidth + "%" }}
          >
            {/* {letter} [data id: {weighting.id}] ({weighting.label}) {weighting.value}% */}
            {Math.round(percentage * 10) / 10}%
          </a>
        </li>
      );
    });

    //
    // ATTRIBUTE ICONS
    //
    const attributes = this.state.winner.data.attributes
        ? this.state.winner.data.attributes
        : [],
      attributesLength = attributes.length;

    let attributesHtml = attributes.map((attribute: any, i: number) => (
      <div className="attribute" key={i}>
        <div
          dangerouslySetInnerHTML={{
            __html: attribute.icon.replace(
              "<title></title>",
              "<title>" + attribute.content + "</title>"
            )
          }}
        />
        {attribute.content}
      </div>
    ));

    //
    // SHARE LINKS
    //
    let prefix = {
      employee: "I am a '",
      employer: "My company is '"
    };
    let suffix = {
      employee: "' according to the Future Workforce Quiz ",
      employer: "' according to the Future Workforce Quiz "
    };
    let shareOnTwitter = (
      <a
        href={
          "https://twitter.com/intent/tweet?text=" +
          encodeURIComponent(
            prefix[this.props.employmentType] +
              this.state.fixedWinner.data.name +
              suffix[this.props.employmentType] +
              "\r"
          ) +
          "&url=" +
          encodeURIComponent("https://www.unum.com/") +
          "&hashtags=unum" +
          "&via=askunum"
        }
        role="button"
        className="twitter"
        target="_blank"
      >
        Share
        <span>on Twitter</span>
      </a>
    );

    let shareOnFacebook = (
      <a
        // href="https://www.facebook.com/sharer/sharer.php?u="
        href={
          "https://www.facebook.com/dialog/share?app_id=145634995501895&display=popup&href=" +
          this.state.url
        }
        role="button"
        className="facebook"
      >
        Share
        <span>on Facebook</span>
      </a>
    );

    return (
      <main className={"employment-type--" + this.props.employmentType}>
        <h1>The Future Workforce: How prepared are you and your business?</h1>
        <div className="results">
          <div className="sidebar">
            <header>
              <h2>Your Results</h2>

              {this.state.data.intro && <p>{this.state.data.intro}</p>}

              {this.props.employmentType == "employer" && (
                <div
                  className="results__description-employer"
                  dangerouslySetInnerHTML={{
                    __html: this.state.winner.data.content
                  }}
                />
              )}
            </header>

            {/* <Graph weightings={this.props.weightings} /> */}

            {this.props.employmentType == "employee" && <ol>{tribeInfo}</ol>}

            <footer>
              <a
                href="https://www.unum.co.uk/future-workforce?utm_source=game&utm_medium=report&utm_campaign=fwf"
                role="button"
                target="_blank"
              >
                Download the Future Workforce Report
              </a>
              <br />
              {shareOnTwitter}
              {shareOnFacebook}

              {/* <div>
              Winner tribe id [0-3]: {this.state.winner.id}
              <br />
              Winner Name: {this.state.winner.data.name}
              <br />
              Employment Type: {this.props.employmentType}
              <br />
            </div>
            <a href="#" onClick={this.reload} role="button">
            Re-take the quiz
            </a> */}
            </footer>
            <div className="arc" />
          </div>
        </div>

        <div className="results__diagram">
          <div className={"attributes attributes--" + attributesLength}>
            {attributesHtml}
          </div>

          <div className={"worker worker--" + (this.state.winner.id + 1)}>
            {this.props.employmentType == "employee" && (
              <div
                dangerouslySetInnerHTML={{
                  __html: this.state.winner.data[
                    // Choose randomly either imageMale or imageFemale
                    Math.random() > 0.5 ? "imageMale" : "imageFemale"
                  ].replace(
                    "<title></title>",
                    "<title>" + this.state.winner.data.name + "</title>"
                  )
                }}
              />
            )}
            {this.props.employmentType == "employer" && (
              <div
                className="employer_result"
                dangerouslySetInnerHTML={{
                  __html: this.state.winner.data.image.replace(
                    "<title></title>",
                    "<title>" + this.state.winner.data.name + "</title>"
                  )
                }}
              />
            )}
            <h2>{this.state.winner.data.name}</h2>
          </div>

          {this.props.employmentType == "employee" && (
            <div
              className="results__description"
              dangerouslySetInnerHTML={{
                __html: this.state.winner.data.content
              }}
            />
          )}
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Results.tsx